export default __webpack_public_path__ + "static/media/carousel2.31d0c82d.jpg";